import { isShellOwnedPath } from "../single-spa-config/apps";

const RETURN_TO_KEY = "shell_return_to";

function isCapturablePath(pathname: string): boolean {
  return pathname.startsWith("/") && !isShellOwnedPath(pathname);
}

export function captureReturnTo(): void {
  const { pathname, search, hash } = window.location;
  if (!isCapturablePath(pathname)) return;
  try {
    sessionStorage.setItem(RETURN_TO_KEY, pathname + search + hash);
  } catch {
    /* storage may be disabled */
  }
}

export function clearReturnTo(): void {
  try {
    sessionStorage.removeItem(RETURN_TO_KEY);
  } catch {
    /* storage may be disabled */
  }
}

export function consumeReturnTo(): string | null {
  let raw: string | null = null;
  try {
    raw = sessionStorage.getItem(RETURN_TO_KEY);
    sessionStorage.removeItem(RETURN_TO_KEY);
  } catch {
    return null;
  }
  if (!raw) return null;
  if (!raw.startsWith("/") || raw.startsWith("//")) return null;
  const pathname = raw.split("?")[0].split("#")[0];
  if (!isCapturablePath(pathname)) return null;
  return raw;
}

export function landingPath(
  emergency: boolean,
  returnTo: string | null,
): string {
  return emergency ? "/marlin-v2/video" : (returnTo ?? "/welcome");
}
